import { ROUTES } from "../../../constant";
import { ScreenTypes } from "../../../enums";
import { iOpenResultDetail } from "../../../context/globalContext/interface";
import { bySource } from "../../../context/sourceContext/SourceContext";

export const isBookingResultDetail = (detail: iOpenResultDetail | null | undefined): boolean =>
  detail?.source === "booking";

export const isResultDetailOnMobileRoute = (detail: iOpenResultDetail, pathname: string): boolean =>
  bySource(detail.source, {
    booking: pathname === ROUTES.BookingInProgress,
    chat: pathname === ROUTES.TopDestination,
    mcp: false,
  });

export const isChatOnDesktopScreen = (firstScreen: string, screen: string): boolean =>
  firstScreen === ScreenTypes.topDestination && screen === "";

export const isResultDetailOnDesktopScreen = (
  detail: iOpenResultDetail,
  firstScreen: string,
  screen: string
): boolean =>
  bySource(detail.source, {
    booking: screen === ScreenTypes.newBooking,
    chat: isChatOnDesktopScreen(firstScreen, screen),
    mcp: false,
  });
